module.exports = __webpack_public_path__ + "static/img/5.4aadb78f.png";